export default {
    version: "305",
    buildNumber: "574",
    baseUrl: "https://cf-st.sc-cdn.net/d/mJaVaSIsblEzSy0An5Tei?go=IgsKCTIBBEgBUFxgAQ%3D%3D&uc=92",
};
